const searchTileType = {
  Event: 'Event',
  Content: 'Content',
  Course: 'Course'
};

export default searchTileType;


// WEBPACK FOOTER //
// ./src/constants/search-tile-type.js